import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'ia-react-core';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ErrorIcon } from '../../../../assets/Robot-error.svg';

import {
  StyledActionBar,
  StyledErrorMessage, StyledIcon, StyledParagraph,
  StyledTitle,
  StyledWrapper,
} from '../../../../pages/ErrorPages.styles';
import { ResourceContextInfo } from '../../ResourcesContext/ResourcesContext';
import redirectTo from '../../../../utils/redirectTo';

export interface ErrorMessageProps {
  onRetry?: () => void;
  retrying?: boolean;
  canRetry?: boolean;
  validateAvailability?: boolean;
  validateAuthorization?: boolean;
  resources: ResourceContextInfo[];
}

const ErrorMessage: FC<ErrorMessageProps> = ({ onRetry, retrying, canRetry, resources, validateAvailability, validateAuthorization }) => {
  const { t } = useTranslation('ErrorMessage');
  const navigate = useNavigate();

  const validateStatus = (status: number) => resources.filter((x) => x.failed).every((x) => x.status === status) || (resources.find((x) => x.essential) && resources.filter((x) => x.essential).every((x) => x.status === status));

  const isUnauthorized = validateAuthorization && validateStatus(403);
  const isUnavailable = validateAvailability && validateStatus(503);

  let translationPrefix = 'technical';
  if (isUnauthorized) {
    translationPrefix = 'unauthorized';
  }
  if (isUnavailable) {
    translationPrefix = 'unavailable';
  }

  return (

    <StyledWrapper>
      <StyledErrorMessage>
        <StyledIcon as={ErrorIcon} />
        <StyledTitle data-testid={`${translationPrefix}ErrorTitle`}>{t(`${translationPrefix}Title`)}</StyledTitle>
        <StyledParagraph>
          {t(`${translationPrefix}Message`)}
          {!canRetry && t('tryLater')}
        </StyledParagraph>
        {
          isUnauthorized ?
            <StyledActionBar>
              <PrimaryButton onClick={() => redirectTo('/', navigate)}>{t('unauthorizedButton')}</PrimaryButton>
            </StyledActionBar>
            :
            canRetry &&
            <StyledActionBar>
              <PrimaryButton onClick={onRetry} busy={retrying}>{t('retryButton')}</PrimaryButton>
            </StyledActionBar>
        }
      </StyledErrorMessage>
    </StyledWrapper>
  );
};
export default ErrorMessage;
